import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router";

import { useApi } from "../api-context";
import {
  persistHeaderConnectionNudgeDismissed,
  readHeaderConnectionNudgeDismissed,
  shouldShowHeaderConnectionNudge,
} from "../header-connection-nudge";

export function HeaderConnectionNudge({
  organizationId,
}: {
  readonly organizationId: string;
}) {
  const api = useApi();
  const [sessionDismissed, setSessionDismissed] = useState(false);
  const connections = useQuery({
    queryKey: ["connections", organizationId],
    queryFn: () => api.connections(organizationId),
    refetchInterval: 60_000,
  });
  const currentPrincipal = useQuery({
    queryKey: ["current-principal"],
    queryFn: () => api.currentPrincipal(),
  });
  const principalId = currentPrincipal.data?.principal_id;
  const dismissed =
    sessionDismissed ||
    (principalId !== undefined &&
      readHeaderConnectionNudgeDismissed(organizationId, principalId));

  if (
    principalId === undefined ||
    connections.data === undefined ||
    !shouldShowHeaderConnectionNudge({
      connections: connections.data.connections,
      principalId,
      dismissed,
    })
  ) {
    return null;
  }

  return (
    <div className="header-connection-nudge" role="status">
      <p className="header-connection-nudge__label">
        No active agent connections
      </p>
      <Link
        className="header-connection-nudge__action"
        to={`/org/${organizationId}/connections`}
        aria-label="Open connections"
      >
        Open
      </Link>
      <button
        className="header-connection-nudge__action"
        type="button"
        onClick={() => {
          persistHeaderConnectionNudgeDismissed(organizationId, principalId);
          setSessionDismissed(true);
        }}
      >
        Dismiss
      </button>
    </div>
  );
}
